import { Portal as MUIPortal } from '@material-ui/core'
import { memo } from 'react'

interface PortalProps {
  targetDomID: string
}

export const Portal = memo(
  ({ children, targetDomID }: React.PropsWithChildren<PortalProps>) => (
    <MUIPortal container={() => document.getElementById(targetDomID)}>
      {children}
    </MUIPortal>
  )
)

Portal.displayName = 'Portal'
